const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;

export const OHOV_RUN_TIME_PLACEHOLDER = "--";

export function formatOHovRecordDurationMs(
  durationMs: number,
  formatMilliseconds: (milliseconds: number) => string,
  formatAtLeastOneSecond: (durationMs: number) => string,
): string | null {
  if (!Number.isFinite(durationMs) || durationMs < 0) return null;
  if (durationMs < ONE_SECOND_MS) {
    return formatMilliseconds(Math.floor(durationMs));
  }
  return formatAtLeastOneSecond(durationMs);
}

/**
 * Format a non-negative duration in milliseconds as a short OHov run time.
 * Examples: `0:05`, `1:23`, `12:34`, `1h 02m`. `null` becomes the placeholder.
 */
export function formatOHovRunTime(durationMs: number | null): string {
  if (durationMs === null) return OHOV_RUN_TIME_PLACEHOLDER;
  if (!Number.isFinite(durationMs) || durationMs < 0) {
    return OHOV_RUN_TIME_PLACEHOLDER;
  }

  if (durationMs >= ONE_HOUR_MS) {
    const hours = Math.floor(durationMs / ONE_HOUR_MS);
    const minutes = Math.floor((durationMs % ONE_HOUR_MS) / ONE_MINUTE_MS);
    return `${hours}h ${pad2(minutes)}m`;
  }

  const minutes = Math.floor(durationMs / ONE_MINUTE_MS);
  const seconds = Math.floor((durationMs % ONE_MINUTE_MS) / ONE_SECOND_MS);
  return `${minutes}:${pad2(seconds)}`;
}

function pad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}
